import React, { useState } from 'react';
import '../App.css';
import { useNavigate, Link } from 'react-router-dom';
import InputMask from 'react-input-mask';
import AuthBanner from '../components/AuthBanner';
import PasswordStrength from '../components/PasswordStrength';
import { FaEnvelope } from 'react-icons/fa';
import { API_ENDPOINTS } from '../config/api';

function Cadastro() {
  const navigate = useNavigate();
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [senhaConfirm, setSenhaConfirm] = useState('');
  const [aceitouTermos, setAceitouTermos] = useState(false);

  const handleCadastro = async (e) => {
    e.preventDefault();

    // Validação dos campos
    if (!nome || !telefone || !email || !senha || !senhaConfirm) {
      alert('Preencha todos os campos!');
      return;
    }
    
    if (senha !== senhaConfirm) {
      alert('As senhas não coincidem!');
      return;
    }

    if (!aceitouTermos) {
      alert('É necessário ler e concordar com os Termos de Uso e a Política de Privacidade.');
      return;
    }

    // Chamada da API
    try {
      const response = await fetch(API_ENDPOINTS.CADASTRO, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          senha,
          nome,
          telefone,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message || 'Cadastro realizado com sucesso! Faça login para acessar.');
        navigate('/login');
      } else {
        if (data.passwordErrors) {
          // Mostrar erros de validação de senha
          const errorMessage = `Senha não atende aos requisitos de segurança:\n${data.passwordErrors.join('\n')}`;
          alert(errorMessage);
        } else {
          alert(data.error || 'Erro ao cadastrar usuário');
        }
      }
    } catch (err) {
      alert('Erro de conexão com o servidor');
    }
  };

  const voltarParaHome = () => {
    navigate('/home');
  };

  return (
    <AuthBanner 
      title="Crie sua conta"
      subtitle="Junte-se ao Claricash e comece a controlar suas finanças"
    >
      <form onSubmit={handleCadastro} className="auth-form">
        <div className="form-group">
          <label className='form-label'>Nome Completo</label>
          <input
            type="text"
            placeholder="Nome e Sobrenome"
            value={nome}
            onChange={e => setNome(e.target.value)}
            required
            className="form-input"
          />
        </div>
        
        <div className="form-group">
          <label className='form-label'>Telefone</label>
          <InputMask
            mask="(99) 99999-9999"
            value={telefone}
            onChange={e => setTelefone(e.target.value)}
          >
            {(inputProps) => (
              <input
                {...inputProps}
                type="text"
                placeholder="Telefone"
                required
                className="form-input"
              />
            )}
          </InputMask>
        </div>
        
        <div className="form-group">
          <label className='form-label'>Email</label>
          <input
            type="email"
            placeholder="Informe seu email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="form-input"
          />
        </div>
        
        <div className="form-group">
          <label className='form-label'>Senha</label>
          <PasswordStrength
            password={senha}
            onPasswordChange={setSenha}
            showRequirements={true}
          />
        </div>
        
        <div className="form-group">
          <label className='form-label'>Confirmar Senha</label> 
          <input
            type="password"
            placeholder="Confirme sua senha"
            value={senhaConfirm}
            onChange={e => setSenhaConfirm(e.target.value)}
            required
            className={`form-input ${senhaConfirm && senha !== senhaConfirm ? 'form-input-error' : ''}`}
          />
          {senhaConfirm && senha !== senhaConfirm && (
            <p className="form-error-msg">As senhas não coincidem.</p>
          )}
        </div>

        <div className="form-group" style={{ marginTop: 8 }}>
          <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 14, lineHeight: 1.45, cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={aceitouTermos}
              onChange={(e) => setAceitouTermos(e.target.checked)}
              style={{ marginTop: 3 }}
              required
            />
            <span>
              Li e concordo com os{' '}
              <Link to="/terms-of-use" target="_blank" rel="noopener noreferrer">
                Termos de Uso
              </Link>{' '}
              e a{' '}
              <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
                Política de Privacidade
              </Link>
              .
            </span>
          </label>
        </div>
        
        <button
          type="submit"
          className="form-button primary"
          disabled={!aceitouTermos}
        >
          Criar conta
        </button>
        
        <div className="form-divider">
          <br />
          <span>ou</span>
        </div>
        
        <button
          type="button"
          className="form-button secondary"
          onClick={voltarParaHome}
        >
          Voltar ao login
        </button>

        {/* Botão de Ajuda */}
        <div className="help-section">
          <button
            type="button"
            className="help-button"
            onClick={() => navigate('/fale-conosco')}
          >
            <FaEnvelope />
            Precisa de ajuda?
          </button>
        </div>
      </form>
    </AuthBanner>
  );
}

export default Cadastro;
